// All third-party ad URLs are kept here so we can adjust or kill them in one place.
export const AD_CONFIG = {
  popunderHead: "https://everybodycollecteagle.com/74/4d/e1/744de1ea939db5317f08c69eaecbcfc3.js",
  nativeBannerSrc:
    "https://pl29498139.effectivecpmnetwork.com/4389c9b215ff8400f5c14bdcb9bc917b/invoke.js",
  nativeBannerContainerId: "container-4389c9b215ff8400f5c14bdcb9bc917b",
  directLink: "https://www.effectivecpmnetwork.com/iwga0a4p31?key=bf978b09fae2048528bdb47972883cfa",
  playDirectLinks: [
    "https://clenchinfer.com/bu3w86g3?key=76f08004a214f29c7fd7b501efd864cf",
    "https://everybodycollecteagle.com/iwga0a4p31?key=bf978b09fae2048528bdb47972883cfa",
  ],
};

// Anything under /admin is admin surface (login + dashboard).
export const isAdminRoute = (pathname) =>
  typeof pathname === "string" && pathname.startsWith("/admin");

// True if we should actually run any ad scripts on the current view.
// Admin token present → no ads anywhere.
export const adsAllowed = (pathname) => {
  if (typeof window !== "undefined" && window.XR_ADMIN_MODE) return false;
  if (isAdminRoute(pathname)) return false;
  return true;
};
